// Module
var code = "<img ng-src=\"{{$ctrl.imageUrl || '/assets/images/avatars/default-site-avatar.png'}}\">";
// Exports
export default code;